import React from "react";
import { useTranslation } from "react-i18next";
import { BundlesBadge } from "@dreamhub/designsystem/icons";
import { ProductTabEmptyState } from "./ProductTabEmptyState";

const TRANSLATION_KEY = "settings.product.bundlesTab";

interface BundlesEmptyStateProps {
  onAddBundle: () => void;
  /** A bundle needs at least one service, so Add bundle waits for one. */
  hasServices: boolean;
}

export const BundlesEmptyState: React.FC<BundlesEmptyStateProps> = ({
  onAddBundle,
  hasServices
}) => {
  const { t } = useTranslation();

  return (
    <ProductTabEmptyState
      badge={<BundlesBadge />}
      badgeClassName="-left-[25px] -top-[15px]"
      title={t(`${TRANSLATION_KEY}.empty.title`)}
      subtitle={t(`${TRANSLATION_KEY}.empty.subtitle`)}
      actionLabel={t(`${TRANSLATION_KEY}.addBundle`)}
      onAction={onAddBundle}
      isActionDisabled={!hasServices}
      actionTooltip={
        hasServices ? undefined : t(`${TRANSLATION_KEY}.noServicesTooltip`)
      }
      dataTest="product-bundles-empty-state"
      actionDataTest="product-bundles-empty-add-button"
    />
  );
};
